import { render, staticRenderFns } from "./HuashuImport.vue?vue&type=template&id=2e2c446c&scoped=true"
import script from "./HuashuImport.vue?vue&type=script&lang=js"
export * from "./HuashuImport.vue?vue&type=script&lang=js"
import style0 from "./HuashuImport.vue?vue&type=style&index=0&id=2e2c446c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c446c",
  null
  
)

export default component.exports